import React, { useContext } from 'react';

const Context = React.createContext();

function DbClientProvider({ dbClient, ...props }) {
  return <Context.Provider value={dbClient} {...props} />;
}

function useDbClient() {
  const context = useContext(Context);
  if (context === undefined) {
    throw new Error('useDbClient must be used within a DbClientProvider');
  }
  return context;
}

export { DbClientProvider, useDbClient };
